import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "service/API";
import { setBacktest } from "store/actionReducers/AnalysisStore";

const useAnalysis = () => {
  const dispatch = useDispatch();

  const fetchStockBacktest = useCallback(async (stock) => {
    const res = await API.Analysis.GetStockBacktest(stock)
    if (res?.code === '0') {

      const dataFilter = filterStockBacktest(res?.data)
      dispatch(setBacktest(dataFilter))
    }
  }, [])

  const filterStockBacktest = (data: any) => {
    let detailBacktest: any = { ...data }
    let chartLeft: any = {
      category: [],
      profitAverage: [],
      profitMax: [],
      profitMin: []
    }

    if (data?.chartLeft && data?.chartLeft.length > 0) {
      data?.chartLeft.map((item: any) => {
        chartLeft.category.push(item?.time)
        chartLeft.profitAverage.push({
          y: item?.profitAverage,
        })
        chartLeft.profitMax.push({
          y: item?.profitMax,
        })
        chartLeft.profitMin.push({
          y: item?.profitMin,
        })
      })
    }

    return { detailBacktest, chartLeft }
  }

  return { fetchStockBacktest }
}

export default useAnalysis